export enum App {
  website = 'website',
  checkout = 'checkout',
  pos = 'pos',
  selfcare = 'selfcare',
  support = 'support',
  roamingCockpit = 'roaming-cockpit',
  smartwatch = 'smartwatch',
}
